import { render, staticRenderFns } from "./BeneficiaryNotCoveredAlert.vue?vue&type=template&id=6f713e1c&scoped=true&"
import script from "./BeneficiaryNotCoveredAlert.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryNotCoveredAlert.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryNotCoveredAlert.vue?vue&type=style&index=0&id=6f713e1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f713e1c",
  null
  
)

export default component.exports